import type { EventSubscription } from "expo-modules-core";

import type {
  CarListItem,
  CarPlaybackEvent,
  CarPlaybackStatus,
  CarPlayDescriptor,
  CarSearchRequest,
  CarTabBarTemplate,
} from "./index";

/** No-op fallback for every platform other than iOS phones. */

const noopSubscription: EventSubscription = { remove: () => undefined };

export const createTemplate = async (
  _: CarTabBarTemplate,
): Promise<string | null> => null;
export const setRoot = async (_: string): Promise<void> => undefined;
export const showNowPlaying = async (): Promise<void> => undefined;
export const play = async (_: CarPlayDescriptor): Promise<void> => undefined;
export const stopPlayback = async (): Promise<void> => undefined;
export const togglePlayPause = async (): Promise<void> => undefined;
export const seekBy = async (_: number): Promise<void> => undefined;
export const getPlaybackStatus = async (): Promise<CarPlaybackStatus> => ({
  state: "stopped",
  position: 0,
});
export const addPlaybackStatusListener = (
  _: (status: CarPlaybackStatus) => void,
): EventSubscription => noopSubscription;
export const addPlaybackEventListener = (
  _: (event: CarPlaybackEvent) => void,
): EventSubscription => noopSubscription;
export const presentAlert = async (_: string): Promise<void> => undefined;
export const setSearchResults = async (
  _: string,
  __: CarListItem[],
): Promise<void> => undefined;
export const isConnected = (): boolean => false;
export const setWindowInterfaceStyle = async (
  _: "dark" | "light" | "unspecified",
): Promise<void> => undefined;
export const addConnectListener = (_: () => void): EventSubscription =>
  noopSubscription;
export const addDisconnectListener = (_: () => void): EventSubscription =>
  noopSubscription;
export const addSearchListener = (
  _: (request: CarSearchRequest) => void,
): EventSubscription => noopSubscription;
export const registerCarService = (
  _: () => () => Promise<void>,
  __: (error: unknown) => void,
): void => undefined;
